/* eslint-disable react-refresh/only-export-components -- co-locating Provider + hook for the incoming-references context is intentional */
import { createContext, useContext, type ReactNode } from 'react';

const IncomingReferencesContext = createContext<Record<string, number>>({});

export function IncomingReferencesProvider({
  value,
  children,
}: {
  value: Record<string, number>;
  children: ReactNode;
}) {
  return (
    <IncomingReferencesContext.Provider value={value}>
      {children}
    </IncomingReferencesContext.Provider>
  );
}

export function useIncomingReferencesMap(): Record<string, number> {
  return useContext(IncomingReferencesContext);
}
